export enum TprmRequirementCategory {
    insurance = 'INSURANCE',
    businessVerification = 'BUSINESS_VERIFICATION',
    credentials = 'CREDENTIALS',
    businessRiskAssessment = 'BUSINESS_RISK_ASSESSMENT',
}
